
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirefc28"];
var parcelRegister = parcelRequire.register;
parcelRegister("92LrB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f4f837bc4fc4ebb0701c77b659a16c91>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $69591a6021d3d3cd$var$_react = $69591a6021d3d3cd$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $69591a6021d3d3cd$var$_baseNew = $69591a6021d3d3cd$var$_interopRequireDefault((parcelRequire("3b3Iv")));
function $69591a6021d3d3cd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LinkExternal".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/link-external
 * Usage guidance:
 * Single purpose - Reserved for links that open up a new tab.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $69591a6021d3d3cd$var$LinkExternalIcon = (props)=>/*#__PURE__*/ $69591a6021d3d3cd$var$_react.default.createElement($69591a6021d3d3cd$var$_baseNew.default, Object.assign({
        name: "LinkExternalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-3H15v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3v1.5zM10 1h4.25a.75.75 0 0 1 .75.75V6h-1.5V3.56L7.53 9.53 6.47 8.47l5.97-5.97H10z" clip-rule="evenodd"/>`
    }, props));
$69591a6021d3d3cd$var$LinkExternalIcon.displayName = 'LinkExternalIcon';
var $69591a6021d3d3cd$var$_default = module.exports.default = $69591a6021d3d3cd$var$LinkExternalIcon;

});


//# sourceMappingURL=@atlaskit-internal_forge-icons--layout-two-columns-sidebar-left.fec469b7.js.map
